<template>
  <sweet-modal
    ref="modal"
    class="vld-parent"
    hide-close-button
    @close="closeModalCleanUp"
  >
    <template #title>
      <strong id="modal-title">{{
        $t('row_categories.container_title')
      }}</strong>
    </template>

    <row-categories-container @category-saved="closeModal" />
  </sweet-modal>
</template>

<script>
import {SweetModal} from 'sweet-modal-vue-3';
import {mapState, mapActions, mapMutations} from 'vuex';
import RowCategoriesContainer from '../row-categories/RowCategoriesContainer.vue';

export default {
  name: 'ExternalContentUrlsModal',
  components: {
    SweetModal,
    RowCategoriesContainer
  },
  computed: {
    ...mapState({
      rowCategories: state => state.rowCategoriesModule.rowCategories,
      externalContentUrlsOpen: state => state.externalContentUrlsOpen,
      externalContentUrlsModified: state => state.externalContentUrlsModified,
      currentPage: state => state.rowCategoriesModule.currentPage
    })
  },
  methods: {
    ...mapActions('rowCategoriesModule', ['retrieveRowCategories']),
    ...mapActions([
      'resolveExternalContentUrls',
      'rejectExternalContentUrls',
      'resetExternalContentUrls'
    ]),
    ...mapMutations([
      'setExternalContentUrlsOpen',
      'setExternalContentUrlsModified'
    ]),
    closeModalCleanUp() {
      this.setExternalContentUrlsOpen(false);
      this.externalContentUrlsModified
        ? this.updateRowCategories()
        : this.rejectExternalContentUrls();
    },
    closeModal() {
      this.$refs.modal.close();
    },
    updateRowCategories() {
      this.resetExternalContentUrls({categories: this.rowCategories});
      this.resolveExternalContentUrls();
    },
    scrollModalToTop() {
      this.$nextTick(() => {
        const root = this.$refs.modal?.$el;
        if (!root) return;

        const modalEl = root.querySelector('.sweet-modal.is-visible');
        if (modalEl) {
          modalEl.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      });
    }
  },
  watch: {
    externalContentUrlsOpen(newValue) {
      if (newValue === true) {
        this.retrieveRowCategories({});
        this.setExternalContentUrlsModified(false);
        this.$refs.modal.open();
      }
    },
    currentPage() {
      this.scrollModalToTop();
    }
  }
};
</script>

<style scoped>
#modal-title {
  text-align: left;
}
</style>
